var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-row",
    [
      _c(
        "w-col",
        { attrs: { xs: "12", md: "6" } },
        [
          _c(
            "w-card",
            [
              _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("title-taxes")))]),
              _c(
                "w-card-content",
                [
                  _c(
                    "w-row",
                    [
                      _c(
                        "w-col",
                        { attrs: { xs: "12", md: "6" } },
                        [
                          _c("w-input-number", {
                            attrs: {
                              decimals: 4,
                              fancy: "",
                              label: _vm.$ct("labels.recupel").toString(),
                            },
                            model: {
                              value: _vm.product.RecupelTax,
                              callback: function ($$v) {
                                _vm.$set(_vm.product, "RecupelTax", $$v)
                              },
                              expression: "product.RecupelTax",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "w-col",
                        { attrs: { xs: "12", md: "6" } },
                        [
                          _c("w-input-number", {
                            attrs: {
                              decimals: 4,
                              disabled: !_vm.hasLeeggoedModule,
                              fancy: "",
                              label: _vm.$ct("labels.leeggoed").toString(),
                            },
                            model: {
                              value: _vm.product.LeeggoedTax,
                              callback: function ($$v) {
                                _vm.$set(_vm.product, "LeeggoedTax", $$v)
                              },
                              expression: "product.LeeggoedTax",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "w-col",
                        { attrs: { xs: "12", md: "6" } },
                        [
                          _c("w-input-number", {
                            attrs: {
                              decimals: 4,
                              fancy: "",
                              label: _vm.$ct("labels.auvibel").toString(),
                            },
                            model: {
                              value: _vm.product.AuvibelTax,
                              callback: function ($$v) {
                                _vm.$set(_vm.product, "AuvibelTax", $$v)
                              },
                              expression: "product.AuvibelTax",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "w-col",
                        { attrs: { xs: "12", md: "6" } },
                        [
                          _c("w-input-number", {
                            attrs: {
                              decimals: 4,
                              fancy: "",
                              label: _vm.$ct("labels.accijnzen").toString(),
                            },
                            model: {
                              value: _vm.product.AccijnzenTax,
                              callback: function ($$v) {
                                _vm.$set(_vm.product, "AccijnzenTax", $$v)
                              },
                              expression: "product.AccijnzenTax",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "w-col",
                        { attrs: { xs: "12", md: "6" } },
                        [
                          _c("w-input-number", {
                            attrs: {
                              decimals: 4,
                              fancy: "",
                              label: _vm.$ct("labels.bebat").toString(),
                            },
                            model: {
                              value: _vm.product.BebatTax,
                              callback: function ($$v) {
                                _vm.$set(_vm.product, "BebatTax", $$v)
                              },
                              expression: "product.BebatTax",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "w-col",
                        { attrs: { xs: "12", md: "6" } },
                        [
                          _c("w-input-number", {
                            attrs: {
                              decimals: 4,
                              fancy: "",
                              label: _vm.$ct("labels.ecoboni").toString(),
                            },
                            model: {
                              value: _vm.product.EcoboniTax,
                              callback: function ($$v) {
                                _vm.$set(_vm.product, "EcoboniTax", $$v)
                              },
                              expression: "product.EcoboniTax",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "w-col",
                        { attrs: { xs: "12", md: "6" } },
                        [
                          _c("w-input-number", {
                            attrs: {
                              decimals: 4,
                              fancy: "",
                              label: _vm.$ct("labels.reprobel").toString(),
                            },
                            model: {
                              value: _vm.product.ReprobelTax,
                              callback: function ($$v) {
                                _vm.$set(_vm.product, "ReprobelTax", $$v)
                              },
                              expression: "product.ReprobelTax",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "w-col",
                        { attrs: { xs: "12", md: "6" } },
                        [
                          _c("w-input", {
                            attrs: {
                              value: _vm.product.FostplusCode,
                              fancy: "",
                              label: _vm.$ct("labels.fostplus-code").toString(),
                            },
                            on: {
                              input: function ($event) {
                                _vm.product.FostplusCode = $event.trim()
                              },
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "w-col",
                        { attrs: { xs: "12", md: "6" } },
                        [
                          _c("w-input-number", {
                            attrs: {
                              decimals: 4,
                              fancy: "",
                              label: _vm.vatExclusiveTaxLabel,
                            },
                            model: {
                              value: _vm.product.CustomVatExclusiveTax,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.product,
                                  "CustomVatExclusiveTax",
                                  $$v
                                )
                              },
                              expression: "product.CustomVatExclusiveTax",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "w-col",
                        { attrs: { xs: "12", md: "6" } },
                        [
                          _c("w-input-number", {
                            attrs: {
                              decimals: 4,
                              fancy: "",
                              label: _vm.vatInclusiveTaxLabel,
                            },
                            model: {
                              value: _vm.product.CustomVatInclusiveTax,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.product,
                                  "CustomVatInclusiveTax",
                                  $$v
                                )
                              },
                              expression: "product.CustomVatInclusiveTax",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-col",
        { attrs: { xs: "12", md: "6" } },
        [
          _c("app-product-edit-intrastat-data", {
            attrs: { product: _vm.product },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }